import { graphql } from '@/gql';
import type { GenerateMarketingAnalyticsPhoneNumberMediaUploadPresignedUrlMutationVariables } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';
import type { PresignedUrl } from '@/models/app';

export const generateMarketingAnalyticsPhoneNumberMediaUploadPresignedUrl = async ({
  fileName,
  phoneNumber,
  contentDisposition,
}: GenerateMarketingAnalyticsPhoneNumberMediaUploadPresignedUrlMutationVariables): Promise<PresignedUrl | null> => {
  const response = await mutationExecute({
    variables: {
      fileName,
      phoneNumber,
      contentDisposition,
    },
    mutation: graphql(`
      mutation GenerateMarketingAnalyticsPhoneNumberMediaUploadPresignedUrl(
        $fileName: String!
        $phoneNumber: String!
        $contentDisposition: String
      ) {
        generateMarketingAnalyticsPhoneNumberMediaUploadPresignedUrl(
          fileName: $fileName
          phoneNumber: $phoneNumber
          contentDisposition: $contentDisposition
        ) {
          url
          key
          accessUrl
        }
      }
    `),
  });

  return response.data?.generateMarketingAnalyticsPhoneNumberMediaUploadPresignedUrl ?? null;
};
